import React from 'react'
import {Charles} from "types/index";
import StarRating from "components/common/StarRating";
import * as Spacer from "components/common/Spacer";
import {convertDateFormat} from "utils/dateFormater";

type Props = {
  answer: Charles.Answer
  maxRating: number
}

const Review = ({answer, maxRating}: Props) => {
  const {firstName, score, feedBack, date} = answer;
  const commaScore = `${score.toFixed(1)}`.replace(".", ",");
  return (
    <div className="review-component">
      <div className="review-component-heading">
        <div className="h4 mb-0 text-white">{firstName}</div>
        <div className="d-flex align-content-center">
          <StarRating starSize={16} rating={score} maxRating={maxRating} />
          <div className="review-component-rating">{commaScore}</div>
        </div>
      </div>
      {feedBack && (<div className="mb-3">{feedBack}</div>)}
      <div className="review-component-date">{convertDateFormat(date)}</div>
    </div>
  );
}

export default Review
